/**
 * Part-number prefix (first 2 digits) → YouTube embed URL.
 * Same lookup pattern as SCS-CART-01-EMPTY-CART videoMapping.
 */
export const videoMapping: Record<string, string> = {
  "11": "https://www.youtube.com/embed/n8PluUJHd-k",
  "18": "https://www.youtube.com/embed/n8PluUJHd-k",
  "15": "https://www.youtube.com/embed/n8PluUJHd-k",
  "12": "https://www.youtube.com/embed/wHpMWRBPkT0",
  "19": "https://www.youtube.com/embed/wHpMWRBPkT0",
  "13": "https://www.youtube.com/embed/adnllm7RJ_4",
  "14": "https://www.youtube.com/embed/adnllm7RJ_4",
  "16": "https://www.youtube.com/embed/pwfXVOhO548",
  "17": "https://www.youtube.com/embed/pwfXVOhO548",
  "21": "https://www.youtube.com/embed/E2kyu2DcOzI",
  "22": "https://www.youtube.com/embed/rD7s5MdNoCY",
  "23": "https://www.youtube.com/embed/osSoD2nwmIY",
  "24": "https://www.youtube.com/embed/oHh_RacL3yY",
  "25": "https://www.youtube.com/embed/oHh_RacL3yY",
  "31": "https://www.youtube.com/embed/sp0ZGH_47jo",
  "32": "https://www.youtube.com/embed/QVVvLGBd3S4",
  "41": "https://www.youtube.com/embed/QyDgZ4rbwEw",
  "43": "https://www.youtube.com/embed/QyDgZ4rbwEw",
  "45": "https://www.youtube.com/embed/QyDgZ4rbwEw",
  "42": "https://www.youtube.com/embed/3fTGf_4bzX0",
  "44": "https://www.youtube.com/embed/3fTGf_4bzX0",
  "46": "https://www.youtube.com/embed/3fTGf_4bzX0",
};

/** Resolve embed URL from a part number's first two digits, or undefined if none. */
export function getVideoUrlForPartNumber(partNumber: string | null | undefined): string | undefined {
  if (!partNumber) return undefined;
  const prefix = String(partNumber).trim().substring(0, 2);
  return prefix ? videoMapping[prefix] : undefined;
}
